// src/protectedroute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./authprovider"; // Adjust the import path as necessary

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();

  if (!user) {
    // If not authenticated, redirect to login
    return <Navigate to="/login" />;
  }

  // If authenticated, render the children components
  return children;
};

export default ProtectedRoute;
